<template>
    <footer class="main-footer" :class="$mq">
        <p class="copyright">© Interactive Media Showcase {{ year }}</p>
        <base-button type="router-link" to="/contact" design="secondary">
            Contact Us
        </base-button>
    </footer>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'main-footer',

        computed: {
            year() {
                return moment().format('YYYY');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .main-footer {
        background: rgba(#f9f9f9, 0.8);
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: $footer-height;
        padding: 0 $standard-space;

        .copyright {
            font-size: 14px;
            color: $purple;
        }

        &.mobile {
            .copyright {
                font-size: 10px;
            }
        }
    }
</style>
